import React from 'react';
import HomeCarousel from './HomeCarousel';
import HomeAbout from './HomeAbout';
import ProductList from './ProductList';
import HomeFeaturedSpotlight from './HomeFeaturedSpotlight';
import PageRichText from './PageRichText';
import HeroBigText from './HeroBigText';
import HeroImage from './HeroImage';
import ImageWithRichText from './ImageWithRichText';
import TwoImagePanel from './TwoImagePanel';
import FullWidthVideo from './FullWidthVideo';
import VideoRichText from './VideoRichText';
import Sustainability from './Sustainability';
import FeaturedDesigner from './FeaturedDesigner';
import RichTextFullWidth from './RichTextFullWidth';
import HeroFullWidthImage from './HeroFullWidthImage';
import HeroTwoColumns from './HeroTwoColumns';

export default ({ product, components = [] }) => {
  return (
    <React.Fragment>
      {components &&
        components.map((component, index) => {
          switch (component._type) {
            case 'heroFullWidth':
              return (
                <HeroFullWidthImage
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'heroTwoColumn':
              return (
                <HeroTwoColumns
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'homeHeroCarousel':
              return (
                <HomeCarousel
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'homeAbout':
              return (
                <HomeAbout index={index} key={component._key} {...component} />
              );
            case 'homeFeaturedSpotlight':
              return (
                <HomeFeaturedSpotlight
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'homeFeaturedProducts':
              return (
                <ProductList
                  title="Featured Products"
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'pageHeroRichText':
              return (
                <PageRichText
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'pageHeroBigText':
              return (
                <HeroBigText
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'pageHeroImage':
              return (
                <HeroImage index={index} key={component._key} {...component} />
              );
            case 'imageRichText':
              return (
                <ImageWithRichText
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'videoRichText':
              return (
                <VideoRichText
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'fullWidthVideo':
              return (
                <FullWidthVideo
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'twoImagePanel':
              return (
                <TwoImagePanel
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'featuredDesigner':
              return (
                <FeaturedDesigner
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'sustainability':
              return (
                <Sustainability
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'suggestedProducts':
              return (
                <ProductList
                  title="Suggested Products"
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'richTextFullWidth':
              return (
                <RichTextFullWidth
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            default:
              return null;
          }
        })}
    </React.Fragment>
  );
};
